import { VisionFilterKey } from '@wizeoo/akm-message-lib';
import { WizConstants } from '../../model/constants';
import { DATA_KIND } from '../../model/enums';
import { ChronocodeVO } from '../core/chronocode.vo';
import { FreeDataVO } from '../core/freedata.vo';
import { Model } from '../../model/model';

/**
 * VO représentant une clé de filtre de vision
 * Réduit à son minimum pour utilisation par le moteur
 */
export class VisionFilterKeyVO {

    constructor(model: Model, pSource: VisionFilterKey) {
        this._model = model;
        this._source = pSource;
        this.build(model);
    }

    /** Le modèle */
    protected _model: Model;

    /** L'objet source provenant du back */
    protected _source: VisionFilterKey;

    public get source(): VisionFilterKey {
        return this._source;
    }
    public set source(value: VisionFilterKey) {
        this._source = value;
    }

    public get code(): string {
        return this._source.code;
    }

    public dataKind: string; // le type de données, précis (Int, Number, Date, Bool, String)

    public isFD: boolean = false; // c'est un FD

    public isChrono: boolean = false; // c'est un chronocode

    private _relatedFd: FreeDataVO = null; // le freedataSource. Level 1 pour les collection plates

    private _relatedChrono: ChronocodeVO = null; // le chronocodeLevel source.

    /* ################################################
     *    init : définition du type et des labels
     * ################################################ */
    private build(model: Model) {
        if (this.code?.startsWith('CHRONO')) {
            // La key est liée à un chronocodelevel
            this._relatedChrono = model.chronocodeEngine.getChronocode(this._source.chronoCode);
            this.isChrono = true;
            this.dataKind = DATA_KIND.DATE;
        } else {
            // la key est liée à un freeData
            const fdv: string = this.code.split(WizConstants.CONTEXT_SEPARATOR)[0]; // prise du level
            this._relatedFd = model.freedataEngine.getFreeData(fdv);
            this.isFD = true;
            this.dataKind = this._relatedFd?.dataType || DATA_KIND.STRING;
        }
    }

    /* ############################################
     *       Collecte des VOs
     * ############################################ */

    public getRelatedFd(): FreeDataVO {
        return this._relatedFd;
    }

    public getRelatedChrono(): ChronocodeVO {
        return this._relatedChrono;
    }

}
